module.exports = __webpack_public_path__ + "img/white-draganddrop.69941550.svg";